  <!--  抗衰重点项目 -->
  <template>
    <div class="box">
        <div class="tab-box">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedRegion.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup"
                    class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedStore.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="name" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机"
                        left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
            <div class="date-box flex flex-between">
                <div class="date">
                    <div class="arrow-box">
                        <div class="arrow-l" @click="handleCalendar('prev')"></div>
                    </div>
                    <div>{{year}}年{{month}}月</div>
                    <div class="arrow-box">
                        <div class="arrow-r" @click="handleCalendar('next')"></div>
                    </div>
                </div>
            </div>
            <div class="select-item-box flex-y-center flex-between">
                <div class="select-box select-box-more flex-y-center flex-start">
                    <div class="select-item flex-between flex-y-center" @click="selectOneItemPopup">
                        <div class="select-tit">{{ checkedOneItem && checkedOneItem.name }}</div>
                        <van-icon name="play" class="select-arrow" />
                    </div>
                </div>
                <div class="select-box select-box-more flex-y-center flex-start">
                    <div class="select-item  flex-between flex-y-center" @click="selectTwoItemPopup">
                        <div class="select-tit">{{ checkedTwoItem && checkedTwoItem.name }}</div>
                        <van-icon name="play" class="select-arrow" />
                    </div>
                </div>
                <div class="select-box select-box-more flex-y-center flex-start">
                    <div class="select-item flex-between flex-y-center" @click="selectThreeItemPopup">
                        <div class="select-tit">{{ checkedThreeItem && checkedThreeItem.name }}</div>
                        <van-icon name="play" class="select-arrow" />
                    </div>
                </div>
                <div class="select-box select-box-more flex-y-center flex-start">
                    <div class="select-item mr-0 flex-between flex-y-center" @click="selectEmployeePopup">
                        <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                        <van-icon name="play" class="select-arrow" />
                    </div>
                </div>
            </div>
        </div>
        <div class="num-box flex-y-center flex-between">
            <div class="flex-col flex-y-center">
                <div class="num-tit">客单价：<span class="num">{{topData.custOrder}}%</span></div>
                <div class="num-txt">（{{topData.custOrderData}})</div>
            </div>
            <div class="flex-col flex-y-center">
                <div class="num-tit">来店率：<span class="num">{{topData.toOrderRate}}%</span></div>
                <div class="num-txt">（{{topData.toOrderData}})</div>
            </div>
            <div class="flex-col flex-y-center">
                <div class="num-tit">复购率：<span class="num">{{topData.twoBuyRate}}%</span></div>
                <div class="num-txt">（{{topData.twoBuyData}})</div>
            </div>
        </div>
        <!-- <div class="select-box flex-y-center flex-end">
            <div class="select-item flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div> -->
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" @load="getList" finished-text="没有更多了"
                    :offset="20" :immediate-check="false">
                    <div class="customer-list" v-for="(item, index) in projectList" :key="index"
                        @click="toDetail(item.custId,item.phone)">
                        <div class="top-box">
                            <div class="flex-row">
                                <img class="customerHeadPortrait" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                                <div class="customer-info flex-1">
                                    <div class="flex-1 flex-y-center flex-start">
                                        <div class="customer-name">{{item.name}}</div>
                                        <img class="card-icon" referrerpolicy="no-referrer" v-if="item.cardImageSmallUrl"
                                            :src="item.cardImageSmallUrl" alt="" />
                                        <div class="customer-name flex-1 flex-y-center flex-end"> <img class="arrow_right"
                                                referrerpolicy="no-referrer" alt=""
                                                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                                        </div>
                                    </div>
                                    <div class="churn-time">
                                        健康顾问：{{item.empName}}
                                    </div>
                                    <div class="churn-time">
                                        项目购买次数：{{item.buyCnt}}次
                                    </div>
                                    <div class="churn-time">
                                        项目剩余金额：{{item.balance}}元
                                    </div>
                                    <div class="churn-time">
                                        项目消费次数：{{item.saleCnt}}次
                                    </div>
                                    <div class="churn-time">
                                        项目剩余次数：{{item.remainCnt}}次
                                    </div>
                                    <div class="churn-time store-time">最近到诊时间：{{item.latelyTime}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <!-- 筛选产品一级 -->
            <van-popup v-model="showOneItemPopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="产品分类" v-model="checkedOneItem" :list="selectOneItemList" @change="onOneItemChange">
                </picker>
            </van-popup>
            <!-- 二级 -->
            <van-popup v-model="showTwoItemPopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="产品分类" v-model="checkedTwoItem" :list="selectTwoItemList" @change="onTwoItemChange">
                </picker>
            </van-popup>
            <!-- 三级 -->
            <van-popup v-model="showThreeItemPopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="产品分类" v-model="checkedThreeItem" :list="selectThreeItemList" @change="onThreeItemChange">
                </picker>
            </van-popup>
            <!-- 筛选员工 -->
            <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="健康顾问" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange">
                </picker>
            </van-popup>
            <!-- 排序 -->
            <!-- <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
                <picker title="排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
            </van-popup> -->
            <!-- 区经区总 切换区域 -->
            <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
            </van-popup>
            <!-- 区经区总 切换门店 -->
            <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
            </van-popup>
        </div>
    </div>
</template>

  <script>
import request from "@/utils/request";
import { getCookie } from '@/utils'
import { Toast } from 'vant'
import Picker from '@/components/Picker';
import { mapState } from 'vuex'
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'
const SORT_LIST = [{ name: '购买次数降序', id: 1 }]
// 
export default {
    name: "keyProjectComplete",
    components: {
        Picker
    },
    inject: ['reload'],
    data() {
        return {
            projectList: [//列表
            ],
            checkedOneItem: null, // 项目筛选三级
            checkedTwoItem: null,
            checkedThreeItem: null,
            showOneItemPopup: false,
            showTwoItemPopup: false,
            showThreeItemPopup: false,
            employeeList: [],//所选员工
            showEmployeePopup: false,// 选择员工弹窗
            checkedEmployee: {
                id: '女性特护中心',
                name: '女性特护中心' //默认
            },
            activeName: "store", //tab
            tableData: [],
            tableHeader: [],
            year: "",
            month: "",
            name: "",
            postId: 0,
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: 0,
            showRegionPopup: false,
            showRegionStorePopup: false,
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
            sortList: SORT_LIST, // 排序
            checkedSort: SORT_LIST[0],
            showSortPopup: false, // 排序弹窗
            selectOneItemList: [],
            selectTwoItemList: [],
            selectThreeItemList: [],
            topData: {},// 顶部数据

        };
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');

        // 获取当前登陆人所记录的区域门店信息
        getUserLogin().then((res) => {
            if (this.regionPostId.includes(this.postId)) {
                this.checkedRegion.name = res.data.region?.storeName // 当前区域
                this.checkedRegion.id = res.data.region?.id
                if (res.data.store) {
                    this.checkedStore.name = res.data.store.storeName //当前门店
                    this.checkedStore.id = res.data.store.id
                    // 门店列表
                    let params = {
                        id: this.checkedRegion.id
                    }
                    getRegionStoreList(params).then((res) => {
                        this.regionStoreList = res.data
                    })
                }
                // 区域列表
                getRegionStoreList().then((res) => {
                    this.regionList = res.data
                })
                // 如果当前没有选择门店记录，则进入大区页面
                if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                    this.$router.replace({
                        name: "keyProjectCompleteRegionPage"
                    });
                }
            }
            this.getemployeesList();
            this.initdateData();
            this.getSelectOneItem()
        })
    },
    methods: {
        // 初始化时间
        initdateData() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            this.year = year
            this.month = month
        },
        //跳转顾客详情页
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
        // 获取列表的数据
        getList() {
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                // overlay: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });
            this.loading = true
            let params = {
                limit: 10,
                page: this.page,
                date: this.year + "-" + this.month,
                name: this.name,
                empId: this.checkedEmployee.id, // 主任级别以上 筛选员工拿到的empid
                category: this.checkedThreeItem.id
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: "/index/briefing/reachPage",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.projectList = this.page == 1 ? res.data.list : this.projectList.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.finished = false;
                    Toast.clear();
                    if (this.projectList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        // 获取顶部的数据
        getTopData() {
            let params = {
                date: this.year + "-" + this.month,
                name: this.name,
                empId: this.checkedEmployee.id, // 主任级别以上 筛选员工拿到的empid
                category: this.checkedThreeItem.name
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: "/index/briefing/reach",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.topData = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 切换月份
        handleCalendar(handle) {
            this.page = 1;
            const year = this.year;
            const month = this.month;
            this.projectList = [];
            if (handle === "prev") {
                let newMonth = month - 1;
                let newYear = year;
                if (newMonth < 1) {
                    newYear = year - 1;
                    newMonth = 12;
                }
                this.year = newYear
                this.month = newMonth
                this.onRefresh();

            } else {
                let newMonth = month + 1;
                let newYear = year;
                if (newMonth > 12) {
                    newYear = year + 1;
                    newMonth = 1;
                }
                this.year = newYear
                this.month = newMonth
                this.onRefresh();
            }
        },
        // 查询
        onSearch(e) {
            this.name = e
            this.onRefresh();
        },
        //清除搜索
        selClear() {
            this.name = "";
            this.onRefresh();
        },
        // 刷新
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.projectList = [];
            this.refreshing = false;
            this.getList();
            this.getTopData()
        },
        // 获取员工信息
        getemployeesList() {
            request({
                url: `/sys/params/selectByStoreTreasure`,
                method: "get",
                params: {
                    storeId: this.checkedStore.id,
                    id: this.checkedStore.id
                }
            })
                .then((res) => {
                    if (res.data.length > 0) {
                        this.employeeList = res.data
                        this.checkedEmployee = this.employeeList[0] //默认全部
                    }
                })
                .catch((error) => {
                    console.log(error);
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                })
        },
        // 筛选菜单多级
        getSelectOneItem() {
            request({
                url: `/index/briefing/reach/pull?parId=0&grade=1`,
                method: "get",
            })
                .then((res) => {
                    if (res.data.length > 0) {
                        this.selectOneItemList = res.data
                        this.checkedOneItem = this.selectOneItemList[0]
                        this.getSelectTwoItem()
                    }
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                })
        },
        getSelectTwoItem() {
            request({
                url: `/index/briefing/reach/pull?parId=${this.checkedOneItem.name}&grade=2`,
                method: "get",
            })
                .then((res) => {
                    if (res.data.length > 0) {
                        this.selectTwoItemList = res.data
                        this.checkedTwoItem = this.selectTwoItemList[0]
                        this.getSelectThreeItem()
                    }
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                })
        },
        getSelectThreeItem() {
            request({
                url: `/index/briefing/reach/pull?parId=${this.checkedTwoItem.name}&grade=3`,
                method: "get",
            })
                .then((res) => {
                    if (res.data.length > 0) {
                        this.selectThreeItemList = res.data
                        this.checkedThreeItem = this.selectThreeItemList[0]
                        this.getList();
                        this.getTopData()
                    }
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                })
        },
        selectOneItemPopup() {
            this.showOneItemPopup = true
        },
        selectTwoItemPopup() {
            this.showTwoItemPopup = true
        },
        selectThreeItemPopup() {
            this.showThreeItemPopup = true
        },
        selectEmployeePopup() {
            this.showEmployeePopup = true
        },
        onOneItemChange(data) {
            this.checkedOneItem = data
            this.showOneItemPopup = false
            this.getSelectTwoItem()
        },
        onTwoItemChange(data) {
            this.checkedTwoItem = data
            this.showTwoItemPopup = false
            this.getSelectThreeItem()
        },
        onThreeItemChange(data) {
            this.checkedThreeItem = data
            this.showThreeItemPopup = false
            this.onRefresh()
        },
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.onRefresh()
        },
        // 排序
        selectSortPopup() {
            this.showSortPopup = true
        },
        onSortChange(data) {
            this.showSortPopup = false
            this.checkedSort = data
            this.onRefresh()
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    this.reload();
                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.checkedStore = data
            this.showRegionStorePopup = false
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then((res) => {
                this.reload();
            })
        },
    },
};
</script>

<style scoped lang="less">
.box {
    height: 100%;
}
.tab-box {
    width: 750px;
}
.data-list {
    height: 80vh;
    overflow-y: auto;
}

.title-tab-box {
    padding: 30px 30px 0 30px;
    :deep(.van-tabs__line) {
        display: none;
    }
    :deep(.van-tab) {
        width: 190px;
        padding: 0 !important;
        height: 70px !important;
        line-height: 70px !important;
        color: #a0acb5;
        font-size: 30px;
    }
    :deep(.van-tab.van-tab--active) {
        height: 70px !important;
        line-height: 70px;
        background: #2fd0d5 !important;
        border-radius: 35px !important;
        color: #fff !important;
    }
}
.date-box {
    height: 42px;
    margin: 25px 30px;
    .date {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        color: #35434c;
    }
    .arrow-l {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-right: 30px;
    }
    .arrow-r {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-left: 30px;
    }
}
.select-item-box {
    margin: 27px 30px;
}
.select-box {
    z-index: 99;
    padding: 30px;
    .select-item {
        margin-right: 15px;
    }
    .select-item.mr-0 {
        margin-right: 0px;
    }
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}
.select-box-more {
    padding: 0;
}
.van-pull-refresh {
    min-height: 100%;
}
.list-box {
    margin: 0 30px;
    height: calc(100vh - 560px);
    overflow-y: auto;
    padding-bottom: 30px;
}
.customer-list {
    width: 690px;
    background: #fafafe;
    border-radius: 20px;
    margin-bottom: 20px;
    .top-box {
        padding: 20px 20px 20px 20px;
        .customer-name {
            min-width: 60px;
            font-size: 30px;
            color: #35434c;
            font-weight: 700;
        }
        .churn-time {
            height: 37px;
            font-size: 26px;
            color: #a0acb5;
            line-height: 37px;
            margin-top: 6px;
        }
        .store-time {
            margin-top: 4px;
        }
        .card-icon {
            width: 90px;
            height: 34px;
            margin-left: 10px;
        }
        .arrow_right {
            width: 15px;
            height: 26px;
        }
        .customerHeadPortrait {
            width: 90px;
            height: 90px;
            border-radius: 45px;
            margin-right: 20px;
        }
    }
}

.num-box {
    width: 690px;
    height: 109px;
    background: #fafafe;
    border-radius: 10px;
    margin-left: 30px;
    padding: 20px 30px;
    margin-bottom: 30px;
    .num-tit {
        font-weight: 400;
        font-size: 24px;
        color: #a0acb5;
        .num {
            color: #35434c;
            font-size: 24px;
            font-weight: 700;
        }
    }
    .num-txt {
        font-weight: 400;
        font-size: 22px;
        color: #66757f;
    }
}
.store-box {
    padding: 30px 30px;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}
:deep(.search .van-search) {
    padding: 0 30px !important;
}
:deep(.search .van-search .van-cell) {
    background-color: #f3f5f6 !important;
}
:deep(.search .van-icon) {
    font-size: 28px;
}
:deep(.search .van-search__content) {
    padding-left: 0 !important;
}
:deep(.van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 8px 20px 0 20px !important;
    margin-right: 0 !important;
}

:deep(.van-list__finished-text) {
    height: 280px !important;
}
:deep(.van-tab--active) {
    font-weight: 400 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
:deep(.van-dropdown-menu__bar) {
    // background-color: #f5f6f7 !important;
    height: 40px !important;
    box-shadow: none !important;
}
:deep(.van-dropdown-menu__title::after) {
    border-color: transparent transparent #35434c #35434c !important;
    border-top-width: 7px !important;
    border-right-width: 7px !important;
    border-bottom-width: 7px !important;
    border-left-width: 7px !important;
    border-top-style: solid !important;
    border-right-style: solid !important;
    border-bottom-style: solid !important;
    border-left-style: solid !important;
}
</style>


